import { customerGallery } from "../data";
import { Sparkles } from "lucide-react";
import { ScrollReveal, StaggerContainer, StaggerItem } from "../components/ScrollReveal";

const Gallery = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <section className="relative py-20 lg:py-32 bg-slate-50 overflow-hidden">
        <div className="container-custom relative z-10">
          <div className="max-w-3xl">
            <h1 className="text-4xl md:text-6xl font-semibold tracking-tighter text-slate-900 mb-6">
              Vores <span className="text-blue-600">Kundegalleri</span>
            </h1>
            <p className="text-xl text-slate-600 leading-relaxed">
              Dyk ned i vores univers af 3D-printede løsninger. Her kan du se et udpluk af de mange spændende projekter, vi har skabt sammen med vores kunder.
            </p>
          </div>
        </div>
        <div className="absolute top-0 right-0 w-1/3 h-full bg-slate-100 -skew-x-12 transform translate-x-20 hidden lg:block"></div>
      </section>

      {/* Grid */}
      <section className="py-20">
        <div className="container-custom">
          <StaggerContainer className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-6">
            {customerGallery.map((item) => (
              <StaggerItem key={item.id}>
                <div className="group relative aspect-square overflow-hidden bg-slate-100">
                  <img 
                    src={item.image} 
                    alt={item.alt} 
                    className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-slate-900/40 opacity-0 group-hover:opacity-100 transition-all duration-700 flex items-center justify-center backdrop-blur-[2px]">
                    <div className="p-4 bg-white text-slate-900 shadow-2xl transform translate-y-8 group-hover:translate-y-0 transition-all duration-700">
                      <Sparkles size={24} className="text-blue-600" />
                    </div>
                  </div>
                </div>
              </StaggerItem>
            ))}
          </StaggerContainer>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 md:py-32 bg-slate-900 text-white relative overflow-hidden">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-[15vw] font-black text-white/5 whitespace-nowrap pointer-events-none select-none">
          3DDESIGN
        </div>
        
        <ScrollReveal className="container-custom relative z-10 text-center">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-semibold mb-8 tracking-tight">Har du en idé til et projekt?</h2>
          <p className="text-slate-400 max-w-2xl mx-auto mb-12 text-lg md:text-xl leading-relaxed">
            Vi hjælper dig med at gøre din vision til virkelighed, uanset om det er en lille dekoration eller en stor specialopgave.
          </p>
          <a 
            href="/kontakt" 
            className="inline-flex items-center justify-center px-10 py-5 bg-white text-slate-900 font-semibold hover:bg-blue-50 transition-all rounded-none text-lg shadow-2xl shadow-black/20"
          >
            Kontakt os i dag
          </a>
        </ScrollReveal>
      </section>
    </div>
  );
};

export default Gallery;
